// Sección del detalle (`.detail-section` del mock): título con su línea y el contenido.
import type { ReactNode } from 'react';

const SECTION_TITLE =
    'mb-1.5 border-b border-border pb-1 text-[10px] font-semibold uppercase tracking-[0.05em] text-muted-foreground';

/** Nota de sección vacía o sin fuente, en itálica como el mock. */
export const EMPTY_NOTE = 'text-[11px] italic text-muted-foreground';

export function DetailSection({ title, children }: { title?: string; children: ReactNode }) {
    return (
        <div className="mb-3.5">
            {title === undefined ? null : <h4 className={SECTION_TITLE}>{title}</h4>}
            {children}
        </div>
    );
}
